/**
 * PROGÈRE — Identifiant du module courant.
 * Chaque application PROGÈRE fixe ces valeurs à l'installation.
 * Elles servent au système universel de versions & release notes.
 */
export const CURRENT_MODULE_CODE = "devis_ai";
export const CURRENT_MODULE_NAME = "DEVIS AI";
export const INITIAL_VERSION = "1.0.0";

/** Modules connus de l'écosystème (pour le menu écosystème et l'admin) */
export const PROGERE_MODULES = [
  { code: "core",     name: "CORE" },
  { code: "punch",    name: "PUNCH" },
  { code: "crm",      name: "CRM" },
  { code: "erp",      name: "ERP" },
  { code: "compta",   name: "COMPTA" },
  { code: "paie",     name: "PAIE" },
  { code: "devis_ai", name: "DEVIS AI" },
  { code: "takeoff",  name: "TAKE OFF" },
  { code: "support",  name: "SUPPORT" },
];

/**
 * URLs des futures fiches boutique (placeholder — à remplacer quand publié)
 * Ces URLs sont utilisées par les composants QR code sur la landing et /app/security.
 *
 * Formats officiels :
 *   Apple App Store  → https://apps.apple.com/app/progere/id{numeric_id}
 *   Google Play      → https://play.google.com/store/apps/details?id=ca.progere.app
 *
 * Tant que l'app n'est pas publiée, un fallback web est utilisé pour que le QR
 * amène l'utilisateur sur la landing web (pas un lien mort).
 */
export const PROGERE_MOBILE_STORES = {
  appStore: {
    published: false,
    url: "https://apps.apple.com/app/progere/id0000000000",   // ← remplacer id0000000000 par le vrai App Store ID au lancement
    fallbackUrl: "https://progere.ca/mobile",
    label: "App Store",
    bundleId: "ca.progere.app",
  },
  googlePlay: {
    published: false,
    url: "https://play.google.com/store/apps/details?id=ca.progere.app",
    fallbackUrl: "https://progere.ca/mobile",
    label: "Google Play",
    packageName: "ca.progere.app",
  },
};

/** Résolveur : retourne l'URL réelle si publié, sinon le fallback */
export function getStoreUrl(store) {
  return store.published ? store.url : store.fallbackUrl;
}
